<template>
  <div class="criar-nova-revisao">
    <div class="overlap-wrapper">
      <div class="overlap">
        <p class="p">Digite o nome da nova revisão:</p>
        <div class="group-2">
          <div class="overlap-2">
            <input class="input-revisao" v-model="description" placeholder="Nome da revisão" type="text" />
          </div>
        </div>
        <hr class="separator" />
        <div class="button-group">
          <div class="red-button" @click="cancelar">
            <div>Cancelar</div>
          </div>
          <div class="green-button" @click="salvarRevisao">
            <div>Salvar</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { urlMainAPI, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "CriarNovaRevisao",
  props: ["planReplaned", "updateHarvestPlan"],
  watch: {},
  data() {
    return {
      description: "",
      planCreated: {
        planId: 0,
        revision: 0
      }
    };
  },
  methods: {
    cancelar() {
      this.$bvModal.hide('replanedProductionPlan');
    },

    async salvarRevisao() {
      let plan = this.planReplaned()
      const payload = { ...plan, description: this.description };
      const url = `${urlMainAPI}/replanandcreateversionoftheplan`

      await axios
        .post(url, payload)
        .then((res) => {
          if (res.statusText === "OK") {
            this.planCreated.planId = res.data.result.maxId
            this.planCreated.revision = res.data.result.maxRevision
            this.planCreated.noReload = true
            defaultSuccess(res.data.message)
            this.$emit("updateHarvestPlan", this.planCreated)
            this.$bvModal.hide('replanedProductionPlan');
          } else {
            alert('Erro ao salvar a revisão');
          }
          this.cancelar();
        })
        .catch(function (e) {
          console.log(e)
        });
    }
  },
  created() { }
};
</script>

<style>
.separator {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 20px 0;
}

.button-group {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.green-button,
.red-button {
  width: 75px;
  padding: 5px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
}

.green-button {
  background-color: #4db55d;
  color: white;
}

.red-button {
  background-color: #c82333;
  color: white;
}

.green-button:hover {
  background-color: #45a049;
}

.red-button:hover {
  background-color: #e53935;
}

.input-revisao {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.p {
  margin-bottom: 10px;
  font-family: "Roboto-SemiBold", Helvetica;
}
</style>
